<template>
  <div class="form">

<div ><h3> Engangsfuldmagt til GLS</h3>

</div>

    <form-group>

    <TextInput

            v-model= "$v.parcel.parcelnumber.$model"
:disabled="true"
        label="Pakkenr."
        id="Pakkenummer"
      />


    </form-group>

    <form-group>
      <TextInput
              v-model="$v.parcel.zipcode.$model"
              label="Postnr."
              id="Zipcode"
              :disabled="true"
      />
    </form-group>


    <small style="color:grey;display: block; margin-top: 4px">Hvor må vi stille pakken?*</small>
    <FormGroup class="column">
      <SelectInput
        :items="options"
        required
        id="location"
        v-model="$v.parcel.location.$model"
        itemText="text"
        itemValue="id"
        :error="$v.parcel.location.$error"
        :errorMessage="!$v.parcel.location.required ? 'Vælg lokation' : ''"
        small
        full-width
        class="select"
      />
    </FormGroup>
    <small style="color:grey;display: block; margin-top: 4px">Yderligere beskrivelse – eks. i hjørnet ved den lille værktøjskasse (maks. 50 tegn) *</small>
    <form-group>
      <TextInput
              v-model="$v.parcel.extra.$model"
              id="extra"
              required
              :max="50"
              :error="$v.parcel.extra.$error"
              :errorMessage="
          !$v.parcel.extra.required && $v.parcel.location.$model !== null
            ? `Tilføj yderligere beskrivelse`
            : ''"
              fullWidth
              class="input"
              placeholder=""
      />
    </form-group>
    <FormGroup>
      <TextInput
              v-model="$v.parcel.mail.$model"
              label="Mail"
              required
              :error="emailErrorValidation"
              :max="50"
              v-on:leave="emailInputLeave"
              :errorMessage="
          !$v.parcel.mail.required
            ? 'Udfyld mail'
            : !$v.parcel.mail.email
            ? 'Indtast gyldig mail'
            : ''
        "
              id="mail"

      />

    </FormGroup>
<br>
      <CheckboxInput
              label="Jeg accepterer hermed også, at ansvaret for pakken overgår til mig, når GLS stiller pakken på det aftalte sted."
              v-model="$v.parcel.acceptConditions.$model"
              @change="$v.acceptConditions.$touch()"
              :error="$v.parcel.acceptConditions.$error"
              errorMessage="Betingelserne skal accepteres"
              style="margin-bottom: 9px;"
      />

    <FormGroup>
      <Button  @click="submit" class="blue"
              :disabled="submitting"
      >

      <span v-if="!submitting"> Bekræft engangsfuldmagt</span>
        <span v-else>Sender...</span>
      </Button
      >
    </FormGroup>

  </div>

</template>

<script>
import TextInput from "@/components/TextInput.vue";
import SelectInput from "@/components/SelectInput.vue";
import CheckboxInput from "@/components/CheckboxInput.vue";
import FormGroup from "@/components/FormGroup.vue";
import Button from "@/components/Button.vue";
//import {isChecked} from "../validators";
import {
  required,
  numeric,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { SignerService } from "../services/SignerService";

export default {
  components: {
    TextInput,
    SelectInput,
    CheckboxInput,
    FormGroup,
    Button
  },
  data() {
    return {
      parcel:JSON.parse(localStorage.getItem("parcel")),
      submitting:false,
      emailErrorValidation:false,
      phoneErrorValidation:false,
      options: [
        { id: 1, text: "I garagen/carporten" },
        { id: 2, text: "På terrassen" },
        { id: 3, text: "Ved bagdøren" },
        { id: 4, text: "I skuret/værkstedet" },
        { id: 5, text: "I legehuset" },
        { id: 6, text: "Under halvtaget" },
        { id: 7, text: "I bryggerset/entreen" },
        { id: 8, text: "I pakkepostkassen" },
        { id: 9, text: "I drivhuset" },
        { id: 10, text: "Andet" }
      ],
      company: false,
    };

  },
  created() {
    this.$v.parcel.location.$model = 1;
  },
  methods: {

    emailInputLeave(){
      this.$v.parcel.mail.$touch();

      if(this.$v.parcel.mail.$error){
        this.emailErrorValidation = true;
      }
      else{
        this.emailErrorValidation = false;
      }
    },
    async submit() {

      this.$v.$touch();
      this.emailInputLeave();
      if (!this.$v.$invalid) {
        this.submitting=true;
        this.$emit('submitting',true);
        const result = await SignerService.saveOnetimePremission({
          parcelnumber: this.$v.parcel.parcelnumber.$model,
          zipcode: this.$v.parcel.zipcode.$model,
          email: this.$v.parcel.mail.$model,
          location:this.options.filter(x=>x.id==this.$v.parcel.location.$model)[0].text,
          extra: this.$v.parcel.extra.$model,
          smsadvice:this.parcel.acceptSmsAdvise,
        });
        if (result.status===200)
        {

          if (result.data.statusCode==200)
          {
            this.$swal({
              icon: 'success',
              title: result.data.message,
              text: 'Pakken '+this.$v.parcel.parcelnumber.$model+ ' stilles: '+this.options.filter(x=>x.id==this.$v.parcel.location.$model)[0].text+' - '+this.$v.parcel.extra.$model,
              confirmButtonColor: '#FFD100',
              iconColor:'#1fa138'
            });
            this.submitting=false;
            this.$emit('submitting',false);
            this.$router.push("/");
          }
          else {
            this.$swal({
              icon: 'error',
              text: result.data.message, confirmButtonColor: '#FFD100',
              footer: '',
              iconColor:'#da202a'
            });
            this.submitting=false;
            this.$emit('submitting',false);

          }


        }
      }

    }
  },
  validations: {
    parcel: {
      parcelnumber: {
        required
      },

      zipcode: {
        required,
        numeric,
        minLength: minLength(4),
        maxLength: maxLength(4)
      },

      mail: {
        required,
        email
      },
      location: {
      },
      extra: {
        required,
        maxLength: maxLength(50)
      },
      acceptConditions: {
        checked (val) {
          return val
        }
      },

    }
  }
};
</script>
<style lang="scss" >

  button {
    overflow: visible;
    width: auto;
  }
.parcel-header{
  display: flex;
  flex-direction: column;
  align-items: center;

}
.header{
  color: #172154;


}
  .p{
    font-size: 11px;
    text-align: left;
      font-family: "NewsonGLS-Regular", Verdana, sans-serif;
  }
.Disabled-text
{
  background-color: gray;
}
  .orderButton
  {

    width: 140px;
    background: #FFD100;
    border-radius: 45px;
    margin-left:auto;
  }
  .wrapper{
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 0px 0px 10px 10px;
    @media screen and(min-width:800px) {
      width: 100%;
      display: flex;
      justify-content: center;
      border: 1px solid #d6d6d6;
      padding: 38px;
      box-shadow: #d6d6d6 0px 0px 30px
    }
  }
  .main {
    margin-bottom: 0.1px !important;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .image-holder{
      width:800px;
      margin-top: 5px !important;
      margin-bottom: 5px !important;
      @media screen and (max-width: 800px) {
        width:100% !important;
        height: 12% !important;

      }
    }

    .logo {
      max-width: 200px;

      display: flex;
      flex-direction: column;
      @media screen and(max-width: 800px){
        flex-direction: row;

      }


      img {
        width: 100%;
      }
      @media screen and (max-width: 1080px) {
        max-width: 600/19.2 * 1vw;
      }
      @media screen and (max-width: 800px) {
        display: flex;
        justify-content: center;
        width: 100%;
        max-width: 100%;
        img {
          width: 50%;
        }
      }
    }
  }


</style>